/* Jilly Socks redesign: quick add, bundle picker, popup. Oniracom. */
(function () {
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('JillyToast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-show'); }, 2600);
  }

  /* Quick add: posts to the cart, then refreshes and opens Dawn's cart drawer when it is on. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jilly-add]');
    if (!btn) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(btn.getAttribute('data-jilly-add')), quantity: 1 }] };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    btn.setAttribute('aria-busy', 'true');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.removeAttribute('aria-busy');
        if (res.status) { toast(res.description || res.message || 'Could not add this pair.'); return; }
        if (drawer && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: res.items && res.items[0] ? res.items[0].id : null, sections: res.sections });
        } else {
          toast((btn.getAttribute('data-jilly-title') || 'Pair') + ' added to your cart.');
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) fetch(window.location.pathname + '?section_id=cart-icon-bubble').then(function (r) { return r.text(); }).then(function (h) {
            var doc = new DOMParser().parseFromString(h, 'text/html');
            var inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          });
        }
      })
      .catch(function () { btn.removeAttribute('aria-busy'); toast('Could not add this pair. Please try again.'); });
  });

  /* Bundle picker: sets the hidden quantity and the Add to cart label. */
  function setTier(wrap, tier) {
    wrap.querySelectorAll('.j-tier').forEach(function (t) { t.setAttribute('aria-pressed', t === tier ? 'true' : 'false'); });
    var qty = wrap.querySelector('[data-jilly-qty]');
    if (qty) qty.value = tier.getAttribute('data-qty');
    var form = document.getElementById(wrap.getAttribute('data-form'));
    var label = form ? form.querySelector('[name="add"] > span') : null;
    var btn = form ? form.querySelector('[name="add"]') : null;
    if (label && btn && !btn.disabled) label.textContent = tier.getAttribute('data-cta');
  }
  function initBundles(root) {
    (root || document).querySelectorAll('[data-jilly-bundle]').forEach(function (wrap) {
      var on = wrap.querySelector('.j-tier[aria-pressed="true"]') || wrap.querySelector('.j-tier');
      if (on) setTier(wrap, on);
    });
  }
  document.addEventListener('click', function (e) {
    var tier = e.target.closest('.j-tier');
    if (!tier) return;
    setTier(tier.closest('[data-jilly-bundle]'), tier);
  });
  document.addEventListener('DOMContentLoaded', function () { initBundles(); });
  document.addEventListener('shopify:section:load', function (e) { initBundles(e.target); });


  /* Review scroller arrows */
  function syncScroller(wrap) {
    var track = wrap.querySelector('.j-quotes'); if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    wrap.querySelectorAll('.j-scroll-btn').forEach(function (b) {
      b.disabled = Number(b.getAttribute('data-dir')) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max;
    });
  }
  function initScrollers(root) {
    (root || document).querySelectorAll('[data-jilly-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('.j-quotes');
      if (!track || track.dataset.jillyBound) return;
      track.dataset.jillyBound = '1';
      track.addEventListener('scroll', function () { syncScroller(wrap); }, { passive: true });
      syncScroller(wrap);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.j-scroll-btn'); if (!b) return;
    var wrap = b.closest('[data-jilly-scroller]'); var track = wrap && wrap.querySelector('.j-quotes'); if (!track) return;
    var card = track.querySelector('.j-quote');
    var step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth;
    track.scrollBy({ left: step * Number(b.getAttribute('data-dir')), behavior: 'smooth' });
  });
  document.addEventListener('DOMContentLoaded', function () { initScrollers(); });
  document.addEventListener('shopify:section:load', function (e) { initScrollers(e.target); });
  window.addEventListener('resize', function () { document.querySelectorAll('[data-jilly-scroller]').forEach(syncScroller); });


  /* 3-Pack builder: pick N designs, add them in one step. The automatic discount prices the pack in the cart. */
  function packState(root) { if (!root._pack) root._pack = []; return root._pack; }
  function packRender(root) {
    var size = Number(root.getAttribute('data-size') || 3), picks = packState(root);
    root.querySelectorAll('.j-pack__slot').forEach(function (slot, i) {
      var p = picks[i];
      slot.classList.toggle('is-filled', !!p);
      if (p) {
        slot.innerHTML = '<img src="' + p.img + '" alt=""><span class="j-pack__x" aria-hidden="true">&times;</span>';
        slot.setAttribute('aria-label', 'Remove ' + p.title + ' from slot ' + (i + 1));
      } else {
        slot.innerHTML = '<span class="j-pack__slot-num">' + (i + 1) + '</span>';
        slot.setAttribute('aria-label', 'Empty slot ' + (i + 1));
      }
    });
    root.querySelectorAll('[data-pack-add]').forEach(function (b) {
      var n = picks.filter(function (p) { return p.id === b.getAttribute('data-variant'); }).length;
      b.classList.toggle('is-picked', n > 0);
      var c = b.querySelector('.j-pack__count'); if (c) c.textContent = n > 1 ? 'x' + n : (n ? '✓' : '');
    });
    var left = size - picks.length, status = root.querySelector('[data-pack-status]');
    if (status && !root._packMsg) status.textContent = left === size ? 'Pick ' + size + ' designs to start.' : (left > 0 ? 'Pick ' + left + ' more.' : 'Your pack is ready.');
    root._packMsg = null;
    var btn = root.querySelector('[data-pack-submit]'); if (btn) btn.disabled = left !== 0;
  }
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-jilly-pack]'); if (!root) return;
    var size = Number(root.getAttribute('data-size') || 3), picks = packState(root);
    var add = e.target.closest('[data-pack-add]');
    if (add && !add.disabled) {
      if (picks.length >= size) { root._packMsg = 1; root.querySelector('[data-pack-status]').textContent = root.getAttribute('data-full-msg'); packRender(root); return; }
      picks.push({ id: add.getAttribute('data-variant'), title: add.getAttribute('data-title'), img: add.getAttribute('data-img') });
      packRender(root); return;
    }
    var slot = e.target.closest('.j-pack__slot.is-filled');
    if (slot) { picks.splice(Number(slot.getAttribute('data-slot')), 1); packRender(root); return; }
    var submit = e.target.closest('[data-pack-submit]');
    if (submit && !submit.disabled) {
      var qty = {}; picks.forEach(function (p) { qty[p.id] = (qty[p.id] || 0) + 1; });
      var items = Object.keys(qty).map(function (id) { return { id: Number(id), quantity: qty[id], properties: { _bundle: '3-Pack' } }; });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
      submit.setAttribute('aria-busy', 'true'); submit.disabled = true;
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        submit.removeAttribute('aria-busy');
        if (res.status) { toast(res.description || res.message || 'Could not add your pack.'); packRender(root); return; }
        root._pack = []; root._packMsg = 1;
        root.querySelector('[data-pack-status]').textContent = root.getAttribute('data-added-msg');
        packRender(root);
        if (drawer && res.sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: res.items && res.items[0] ? res.items[0].id : null, sections: res.sections }); }
        else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      }).catch(function () { submit.removeAttribute('aria-busy'); toast('Could not add your pack. Please try again.'); packRender(root); });
    }
  });

  /* Star rating link scrolls to the reviews app section. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.j-pdp-rating[href="#reviews"]');
    if (!a) return;
    var target = document.querySelector('[id$="__reviews"]');
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
  });

  /* Email popup */
  var KEY = 'jilly-popup-hidden-until';
  function popupEl() { return document.getElementById('JillyPopup'); }
  function openPopup() {
    var p = popupEl(); if (!p) return;
    p.classList.add('is-open'); p.setAttribute('aria-hidden', 'false');
    var input = p.querySelector('input[type="email"]'); if (input) setTimeout(function () { input.focus(); }, 300);
  }
  function closePopup() {
    var p = popupEl(); if (!p) return;
    p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true');
    var days = Number(p.getAttribute('data-days') || 14);
    try { localStorage.setItem(KEY, String(Date.now() + days * 864e5)); } catch (err) {}
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jilly-popup-close]')) { e.preventDefault(); closePopup(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });
  document.addEventListener('DOMContentLoaded', function () {
    var p = popupEl(); if (!p) return;
    /* Shopify returns to #JillyPopupForm after this form posts: reopen to show the result. */
    if (window.location.hash === '#JillyPopupForm') {
      openPopup();
      if (p.querySelector('[data-jilly-popup-success]')) { try { localStorage.setItem(KEY, String(Date.now() + 365 * 864e5)); } catch (err) {} }
      return;
    }
    if (p.getAttribute('data-design') === 'true') return;
    var until = 0;
    try { until = Number(localStorage.getItem(KEY) || 0); } catch (err) {}
    if (until > Date.now()) return;
    setTimeout(openPopup, Number(p.getAttribute('data-delay') || 10) * 1000);
  });
  document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector && e.target.querySelector('#JillyPopup')) openPopup(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector && e.target.querySelector('#JillyPopup')) { var p = popupEl(); if (p) { p.classList.remove('is-open'); } } });
})();
